import * as actionTypes from "../actions/types";
import axios from "../../axios";
import axiosAuth from "../../axiosAuth";
import { openEdifySpinner, openMainModal } from "./profileActions";
import { fireAnalytics } from "../../utils/firebase";
import { clearRegistrationFlow, resendVerificationCode } from "./registerActions";
import { resetOnboarding } from "../onboardingV2/actions.ts";
import { clearFlow as clearRegistrationV2Flow } from "../registrationV2/actions.ts";
import environment from "../../environments/index";
import { getSessionId, getDeviceCategory } from "../../utils/analyticsHelpers.ts";
import {
  userIsJobboardOnlyAccount,
  isExistingClientWithoutJobboardRole,
} from "../../utils/jobboard/jobboardProfileGate.ts";
import { navigateAfterJobboardGoogleLogin } from "../../utils/jobboard/navigateAfterJobboardGoogleLogin.ts";
import { clearCurrentSessionPointer } from "../../utils/conversationStorage.ts";
import { fetchSkillList } from "../../utils/onboardingV2/skillsService.ts";
import { extractUserSkillIdsFromUserData } from "../../utils/commercePrefill.ts";
import { userSkillIdsMatchCommerceCategories } from "../../utils/commerceOnboardingEligibility.ts";
import { userHasCommerceRegistration } from "../../utils/userCommerces.ts";


function clearRegistrationData(dispatch) {
  const registrationKeys = [
    "personaFormNew",
    "empresaFormNew", 
    "userSkillsNew",
    "workZonesNew",
    "allCountryNew",
    "accountTypeNew",
    "userImageNew",
    "EmailRegister"
  ];
  
  registrationKeys.forEach(key => {
    localStorage.removeItem(key);
  });
  
  // Limpiar el estado de Redux del flujo de registro
  if (dispatch) {
    dispatch(clearRegistrationFlow());
  }
}

const setAccess = (values) => {
  return {
    type: actionTypes.SET_ACCESS,
    payload: values,
  };
};

export const validationSuccess = (action) => {
  return {
    type: actionTypes.VALIDATION_SUCCESS,
    payload: action,
  };
};

export const setIsValidating = (value) => {
  return {
    type: actionTypes.SET_IS_VALIDATING,
    payload: value,
  };
};

export const startLoading = () => {
  return { type: actionTypes.SKELETON_START };
};
export const endLoading = () => {
  return { type: actionTypes.SKELETON_END };
};

export const setErrorMessage = (value) => {
  return {
    type: actionTypes.REGISTER_FAIL,
    payload: value,
  };
};

export const expandedSideBar = (value) => {
  return {
    type: actionTypes.EXPANDED_SIDEBAR,
    payload: value,
  };
};

export const openSendContactNotificationModal = (value) => {
  return {
    type: actionTypes.OPEN_SEND_CONTACT_NOTIFICATION_MODAL,
    payload: {
      isOpen: true,
      userData: value,
    },
  };
};

export const closeSendContactNotificationModal = () => {
  return {
    type: actionTypes.CLOSE_SEND_CONTACT_NOTIFICATION_MODAL,
    payload: { isOpen: false, userData: null },
  };
};

export const openCalificationModal = (value) => {
  return {
    type: actionTypes.OPEN_CALIFICATION_MODAL,
    payload: {
      isOpen: true,
      userData: value,
    },
  };
};

export const closeCalificationModal = () => {
  return {
    type: actionTypes.CLOSE_CALIFICATION_MODAL,
    payload: { isOpen: false, userData: null },
  };
};

export const setLoginAnimation = (value) => {
  return {
    type: actionTypes.SET_LOGIN_ANIMATION,
    payload: value,
  };
};

export const setLoginAnimationType = (value) => {
  return {
    type: actionTypes.SET_LOGIN_ANIMATION_TYPE,
    payload: value,
  };
};

export const setLogoutAnimation = (value) => {
  return {
    type: actionTypes.SET_LOGOUT_ANIMATION,
    payload: value,
  };
};
export const setCommerceOnboardingEligible = (value) => {
  return {
    type: actionTypes.SET_COMMERCE_ONBOARDING_ELIGIBLE,
    payload: value === true,
  };
};

async function resolveCommerceOnboardingEligibility(userData) {
  if (!userData?.id) return false;
  if (userHasCommerceRegistration(userData)) return false;
  const skillIds = extractUserSkillIdsFromUserData(userData);
  if (!skillIds.length) return false;
  try {
    const catalog = await fetchSkillList();
    return userSkillIdsMatchCommerceCategories(skillIds, catalog);
  } catch {
    return false;
  }
}

export const refreshCommerceOnboardingEligibility = (userData) => {
  return async (dispatch) => {
    const eligible = await resolveCommerceOnboardingEligibility(userData);
    dispatch(setCommerceOnboardingEligible(eligible));
  };
};
export const setSuccessFalse = () => {
  return {
    type: actionTypes.RECOVERY_START,
  };
};


function parseApiErrorMessage(err, fallback) {
  const raw = err?.response?.data?.message;
  if (Array.isArray(raw) && raw.length) return raw.join(", ");
  if (typeof raw === "string") return raw;
  return fallback;
}

function isJobboardAlreadyClientConflict(err) {
  if (err?.response?.status === 409) return true;
  const msg = err?.response?.data?.message;
  return typeof msg === "string" && /ya\s+es\s+client/i.test(msg);
}

export const activateFreeTrialAuth = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  return (dispatch) => {

    axios
      .get(`/subscription/free-trial/activate`, bearerToken)
      .then((res) => {
      })
      .catch((err) => {
        console.error("Error activating free trial:", err);
      });
  };
};

export const upgradeJobboardToClientAndActivateTrial = () => {
  return async (dispatch, getState) => {
    const authToken = localStorage.getItem("access-Token-Edify");
    const bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
    const trialNeedsActivation =
      getState()?.general?.userData?.free_trial?.status === "no-activated";

    const fireUpgradeSuccessAnalytics = () => {
      fireAnalytics("jobboard_upgrade_to_client_success", {
        category: "authentication",
        action: "upgrade_to_client",
        session_id: getSessionId(),
        device_category: getDeviceCategory(),
      });
    };

    const openLoadingModal = () => {
      dispatch(
        openMainModal({
          isLoading: true,
          title: "Actualizando tu cuenta",
          body: "Esperá un momento mientras aplicamos los cambios.",
          isSuccess: true,
          noActionNeeded: true,
        })
      );
    };

    const openSuccessModal = (alreadyClient) => {
      dispatch(
        openMainModal({
          isSuccess: true,
          iconType: "success",
          title: alreadyClient
            ? "Tu cuenta ya estaba actualizada"
            : "Cuenta actualizada",
          body: alreadyClient
            ? "Tu usuario ya tenía rol cliente. Sincronizamos tu sesión con la información más reciente."
            : "Ya podés usar Edify como miembro completo con tu período de prueba cuando corresponda.",
          noLabel: "Entendido",
          dismiss: true,
          noActionNeeded: false,
        })
      );
    };

    const openErrorModal = (title, body) => {
      dispatch(
        openMainModal({
          isSuccess: true,
          iconType: "error",
          title,
          body,
          noLabel: "Entendido",
          dismiss: true,
          noActionNeeded: false,
        })
      );
    };

    openLoadingModal();

    try {
      await axios.post("/user/upgrade-to-client", {}, bearerToken);
    } catch (err) {
      if (isJobboardAlreadyClientConflict(err)) {
        try {
          await dispatch(loadUserData());
        } catch {
          openErrorModal(
            "No pudimos sincronizar tu cuenta",
            "Recargá la página e intentá de nuevo. Si el problema continúa, contactanos."
          );
          return { success: false };
        }
        fireUpgradeSuccessAnalytics();
        openSuccessModal(true);
        return { success: true, alreadyClient: true };
      }
      openErrorModal(
        "No pudimos completar el cambio",
        parseApiErrorMessage(
          err,
          "No pudimos completar la activación. Intentá de nuevo en unos minutos."
        )
      );
      return { success: false };
    }

    try {
      if (trialNeedsActivation) {
        await axios.get(`/subscription/free-trial/activate`, bearerToken);
      }
    } catch (err) {
      try {
        await dispatch(loadUserData());
      } catch {
        /* ignore */
      }
      openErrorModal(
        "No pudimos activar el período de prueba",
        parseApiErrorMessage(
          err,
          "Tu cuenta puede haber pasado a cliente, pero el trial no se activó. Revisá Mi cuenta o intentá de nuevo."
        )
      );
      return { success: false };
    }

    try {
      await dispatch(loadUserData());
    } catch {
      openErrorModal(
        "No pudimos refrescar tus datos",
        "El cambio puede haberse aplicado. Recargá la página para ver tu cuenta actualizada."
      );
      return { success: false };
    }

    fireUpgradeSuccessAnalytics();
    openSuccessModal(false);
    return { success: true };
  };
};

export const loadUserData = () => {
  let authToken = localStorage.getItem("access-Token-Edify");
  let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };

  return (dispatch) => {
    return axios
      .get("/user/data", bearerToken)
      .then((res) => {
        dispatch({ type: actionTypes.GET_DATA, payload: res.data });
        dispatch(refreshCommerceOnboardingEligibility(res.data));
        if (res.data.type === "PERSON") {
          const {
            dniCuit,
            name,
            lastName,
            profession,
            phone,
            address,
            urlSiteWeb,
            password,
          } = res.data;
          dispatch({
            type: actionTypes.SET_PERSONA_DATA,
            payload: {
              dniCuit,
              name,
              lastName,
              profession,
              phone,
              address,
              urlSiteWeb,
              password,
            },
          });
        }
        return res.data;
      })
      .catch((error) => {
        console.error("Error loading user data:", error);
        return Promise.reject(error);
      });
  };
};

export const loginWithGoogle = (credentials, navigate, options = {}) => {
  const token = credentials;
  const showProfilePostModal = options.showProfilePostModal === true;

  return (dispatch) => {
    dispatch(setLoginAnimation(true));
    clearRegistrationData(dispatch);
    /* Limpiar el estado de registro al hacer login con Google */
    dispatch(clearRegistrationFlow());
    
    axiosAuth
      .get(`/google/login?token=${token}`)
      .then((response) => {
        /* Tomamos los valores de la respuesta y los almacenamos */
        let { access_token, refresh_token, expires_in, name } = response.data;
        /* Despachamos un creador de acciones con los datos para almacenarlos en el reducer  */
        dispatch(
          setAccess({
            access: `Bearer ${access_token}`,
            refresh: `Bearer ${refresh_token}`,
            expire: expires_in,
            name: name,
          })
        );
        /* Guardamos los Token en el LocalStorage */
        localStorage.setItem("access-Token-Edify", access_token);
        localStorage.setItem("access-RefreshToken-Edify", refresh_token);
        /* Login Success trigerea el auth a true, nos logeamos correctamente */
        dispatch({ type: actionTypes.LOGIN_SUCCESS });
        dispatch(resetOnboarding());
        localStorage.removeItem("persist:onboardingV2");
        /* Configuramos el header del get */
        let getUserHeader = {
          headers: { Authorization: `Bearer ${access_token}` },
        };
        /* Pedimos los datos al servidor con la configuracion */
        localStorage.removeItem("toValidateUsername");
        localStorage.removeItem("fromLogin");
        axiosAuth.get("/user/data", getUserHeader).then((res) => {
          dispatch(viewAccessRequest());
          fireAnalytics("login_success_by_google", { 
            category: "authentication", 
            login_google_user_info: res.data.id, 
            edify_user_id: res.data.id, 
            session_id: getSessionId(),
            device_category: getDeviceCategory(),
            login_method: "google",
            user_type: res.data.type || "",
            action: "login_success"
          });
          dispatch({ type: actionTypes.GET_DATA, payload: res.data });
          dispatch(refreshCommerceOnboardingEligibility(res.data));
          if (
            (res.data.name && res.data.last_name) || res.data.razon_social) {
              dispatch(setLoginAnimation(false));
              if (showProfilePostModal) {
                navigate("/dashboard", { state: { showProfilePostModal: true } });
              } else {
                navigate("/dashboard");
              }
          } else {
              dispatch(setLoginAnimation(false));
            navigate("/");
          }
        });
      })
      .catch((error) => {
        console.error(error);
        let errorTitle = "¡Ups!";
        let errorBody = "";
        let isSuccess = false;
        let noLabel = "Cerrar";
        let confirmHandler = null;

        if (error?.response?.data?.message) {
          const errorMessage = error.response.data.message;
          errorBody = `Error del servidor: ${errorMessage}. Por favor, intenta nuevamente o escríbenos a contacto@edify.la si el problema persiste.`;
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        }
        // Errores de red y CORS
        else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
          errorTitle = "Error de Conexión";
          errorBody = "No se pudo conectar con el servidor durante el inicio de sesión con Google. Esto puede deberse a:\n\n• Problemas de conexión a internet\n• El servidor no está disponible\n• Problemas de configuración de red\n\nPor favor, verifica tu conexión e intenta nuevamente. Si el problema persiste, escríbenos a contacto@edify.la";
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        }
        // Errores de CORS específicos
        else if (error.message && error.message.includes("CORS")) {
          errorTitle = "Error de Configuración";
          errorBody = "Se detectó un problema durante el inicio de sesión con Google. Por favor, intenta nuevamente más tarde o escríbenos a contacto@edify.la si el problema persiste.";
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        }
        // Otros errores desconocidos
        else {
          errorTitle = "Error Desconocido";
          errorBody = "Ocurrió un error inesperado durante el inicio de sesión con Google. Por favor:\n\n• Verifica tu conexión a internet\n• Intenta nuevamente en unos minutos\n• Si el problema persiste, escríbenos a contacto@edify.la con los detalles del error\n\nDetalles técnicos: " + (error.message || "Error no especificado");
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        }

        dispatch(openMainModal({
          title: errorTitle,
          body: errorBody,
          iconType: "error",
          isSuccess: isSuccess,
          noLabel: noLabel,
          confirmHandler: confirmHandler,
          customCloseMainModal: () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          },
        }));
        dispatch(setLoginAnimation(false));
      });
  };
};

export const loginWithGoogleJobBoard = (credentials, navigate, options = {}) => {
  const token = credentials;
  const registrationEntry = options.registrationEntry ?? "header";
  const workOfferId = options.workOfferId;
  const isExternalOffer = options.isExternalOffer === true;

  return (dispatch) => {
    dispatch(setLoginAnimation(true));
    clearRegistrationData(dispatch);
    dispatch(clearRegistrationFlow());

    axiosAuth
      .get(`/google/job-board/login?token=${token}`)
      .then((response) => {
        let { access_token, refresh_token, expires_in, name } = response.data;
        dispatch(
          setAccess({
            access: `Bearer ${access_token}`,
            refresh: `Bearer ${refresh_token}`,
            expire: expires_in,
            name: name,
          })
        );
        localStorage.setItem("access-Token-Edify", access_token);
        localStorage.setItem("access-RefreshToken-Edify", refresh_token);
        dispatch({ type: actionTypes.LOGIN_SUCCESS });
        dispatch(resetOnboarding());
        localStorage.removeItem("persist:onboardingV2");
        let getUserHeader = {
          headers: { Authorization: `Bearer ${access_token}` },
        };
        localStorage.removeItem("toValidateUsername");
        localStorage.removeItem("fromLogin");
        axiosAuth.get("/user/data", getUserHeader).then((res) => {
          dispatch(viewAccessRequest());
          fireAnalytics("login_success_by_google_job_board", {
            category: "authentication",
            login_google_user_info: res.data.id,
            edify_user_id: res.data.id,
            session_id: getSessionId(),
            device_category: getDeviceCategory(),
            login_method: "google_job_board",
            user_type: res.data.type || "",
            action: "login_success",
          });
          const userData = res.data;
          dispatch({ type: actionTypes.GET_DATA, payload: userData });
          dispatch(refreshCommerceOnboardingEligibility(userData));
          dispatch(setLoginAnimation(false));
          if (registrationEntry === "header" && isExistingClientWithoutJobboardRole(userData)) {
            dispatch(
              openMainModal({
                title: "Ya tenés cuenta en Edify",
                body: "Esta cuenta está registrada como cliente. Para ingresar, hacelo desde el inicio.",
                iconType: "warning",
                isSuccess: false,
                yesLabel: "Ir al inicio",
                noLabel: "Cerrar",
                confirmHandler: () => {
                  dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
                  navigate("/");
                },
              })
            );
            return;
          }
          navigateAfterJobboardGoogleLogin(navigate, userData, {
            registrationEntry,
            workOfferId,
            isExternalOffer,
          });
        });
      })
      .catch((error) => {
        console.error(error);
        let errorTitle = "¡Ups!";
        let errorBody = "";
        let isSuccess = false;
        let noLabel = "Cerrar";
        let confirmHandler = null;

        if (error?.response?.data?.message) {
          const errorMessage = error.response.data.message;
          errorBody = `Error del servidor: ${errorMessage}. Por favor, intenta nuevamente o escríbenos a contacto@edify.la si el problema persiste.`;
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        } else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
          errorTitle = "Error de Conexión";
          errorBody =
            "No se pudo conectar con el servidor durante el inicio de sesión con Google. Verificá tu conexión e intentá nuevamente.";
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        } else if (error.message && error.message.includes("CORS")) {
          errorTitle = "Error de Configuración";
          errorBody =
            "Se detectó un problema durante el inicio de sesión con Google. Intentá nuevamente más tarde o escríbenos a contacto@edify.la.";
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        } else {
          errorTitle = "Error Desconocido";
          errorBody =
            "Ocurrió un error inesperado durante el inicio de sesión con Google. Intentá nuevamente en unos minutos.";
          isSuccess = true;
          noLabel = "Cerrar";
          confirmHandler = () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
          };
        }

        dispatch(
          openMainModal({
            title: errorTitle,
            body: errorBody,
            iconType: "error",
            isSuccess: isSuccess,
            noLabel: noLabel,
            confirmHandler: confirmHandler,
            customCloseMainModal: () => {
              dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
            },
          })
        );
        dispatch(setLoginAnimation(false));
      });
  };
};

export const loginUserAction = (value, navigate) => {

  clearRegistrationData();

  /* Creamos una instancia de FormData con los datos del login */
  const formData = {
    username: value.email,
    password: value.password,
  };

  return (dispatch) => {
    dispatch({ type: actionTypes.LOGIN_START });
    dispatch(setLoginAnimation(true));
    /* Limpiar el estado de registro al hacer login */
    dispatch(clearRegistrationFlow());
    /* Request con los datos del login y la configuracion */
    axiosAuth
      .post("/oauth/token", formData)
      .then((response) => {
        /* Tomamos los valores de la respuesta y los almacenamos */
        let { access_token, refresh_token, expires_in, name } = response.data;
        /* Despachamos un creador de acciones con los datos para almacenarlos en el reducer  */
        dispatch(
          setAccess({
            access: `Bearer ${access_token}`,
            refresh: `Bearer ${refresh_token}`,
            expire: expires_in,
            name: name,
          })
        );
        /* Guardamos los Token en el LocalStorage */
        localStorage.setItem("access-Token-Edify", access_token);
        localStorage.setItem("access-RefreshToken-Edify", refresh_token);
        /* Login Success trigerea el auth a true, nos logeamos correctamente */
        dispatch({ type: actionTypes.LOGIN_SUCCESS });
        dispatch(resetOnboarding());
        localStorage.removeItem("persist:onboardingV2");
        /* Configuramos el header del get */
        let getUserHeader = {
          headers: { Authorization: `Bearer ${access_token}` },
        };
        /* Pedimos los datos al servidor con la configuracion */
        localStorage.removeItem("toValidateUsername");
        localStorage.removeItem("fromLogin");
        // Limpiar el email del registro al hacer login exitoso
        localStorage.removeItem("EmailRegister");
        axiosAuth.get("/user/data", getUserHeader).then((res) => {
          fireAnalytics("login_success", { 
            category: "authentication", 
            login_user_info: res.data.id, 
            edify_user_id: res.data.id, 
            session_id: getSessionId(),
            device_category: getDeviceCategory(),
            login_method: "email",
            user_type: res.data.type || "",
            action: "login_success"
          });
          dispatch(viewAccessRequest());
          dispatch({ type: actionTypes.GET_DATA, payload: res.data });
          dispatch(refreshCommerceOnboardingEligibility(res.data));
          if (res.data.type === null) {
            dispatch(setLoginAnimation(false));
            navigate("/onboarding");
          } else if
            (
            (res.data.name && res.data.last_name && res.data.type !== null) ||
            (res.data.razon_social && res.data.type !== null)
          ) {
            dispatch(setLoginAnimation(false));
            navigate("/dashboard"); 
          } else {
            dispatch(setLoginAnimation(false));
            navigate("/");
          }
          if (
            res.data.free_trial?.status === "no-activated" &&
            !userIsJobboardOnlyAccount(res.data)
          ) {
            dispatch(activateFreeTrialAuth());
            dispatch(loadUserData());
          }
        });
      })
      .catch((error) => {

        let errorTitle = "¡Ups!";
        let errorBody = "";
        let errorIconType = "error";
        let isSuccess = false;
        let noLabel = "Cerrar";
        let yesLabel = "Completar registro";
        let confirmHandler = null;

        const responseData = error?.response?.data;

        if (responseData?.statusCode === 400 && Array.isArray(responseData.message)) {
          errorBody = responseData.message.includes("username must be an email")
            ? "El email no es válido. Por favor, verifica tu email e intenta nuevamente."
            : responseData.message.join(", ");
          isSuccess = true;
        }
        else if (responseData?.message) {
          const errorMessage = responseData.message;

          switch (errorMessage) {
            case "username must be an email":
              errorBody = "El email no es válido. Por favor, verifica tu email e intenta nuevamente.";
              isSuccess = true;
              break;
            case "Password is wrong":
              errorBody = "La contraseña es incorrecta. Por favor, verifica tu contraseña e intenta nuevamente.";
              isSuccess = true;
              break;
            case "User not found":
              errorBody = "Este email todavía no tiene cuenta en Edify. Registrate y empezá a conectar con profesionales y empresas del sector.";
              noLabel = "Crear cuenta";
              isSuccess = true;
              confirmHandler = () => navigate("/register");
              break;
            case "User not validated":
              errorBody = "Tu cuenta aún no ha sido validada. Por favor, completa el proceso de registro para validar tu cuenta.";
              isSuccess = false;
              noLabel = "Cerrar";
              yesLabel = "Completar registro";
              confirmHandler = () => {
                // Hacer resend del código inmediatamente
                dispatch(resendVerificationCode(value.email));
                // Guardar información necesaria
                localStorage.setItem("EmailRegister", value.email);
                localStorage.setItem("fromLoginValidation", "true");
                // Cerrar modal y navegar con parámetro especial
                dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
                navigate("/register?step=code-validation");
              };
              break;
            default:
              errorBody = `Error del servidor: ${errorMessage}. Por favor, intenta nuevamente o escríbenos a contacto@edify.la si el problema persiste.`;
          }
        }
        // Errores de red y CORS
        else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
          errorTitle = "Error de Conexión";
          errorBody = "No se pudo conectar con el servidor. Esto puede deberse a:\n\n• Problemas de conexión a internet\n• El servidor no está disponible\n• Problemas de configuración de red\n\nPor favor, verifica tu conexión e intenta nuevamente. Si el problema persiste, escríbenos a contacto@edify.la";
          isSuccess = true;
        }
        // Errores de CORS específicos
        else if (error.message && error.message.includes("CORS")) {
          errorTitle = "Error de Configuración";
          errorBody = "Se detectó un problema. Esto suele ocurrir cuando:\n\n• El servidor no está configurado correctamente\n• Hay problemas de configuración en el entorno de desarrollo\n\nPor favor, intenta nuevamente más tarde o escríbenos a contacto@edify.la si el problema persiste.";
          isSuccess = true;
        }
        // Errores de timeout
        else if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
          errorTitle = "Tiempo de Espera Agotado";
          errorBody = "La solicitud tardó demasiado en completarse. Esto puede deberse a:\n\n• Conexión lenta a internet\n• El servidor está sobrecargado\n• Problemas temporales de red\n\nPor favor, intenta nuevamente. Si el problema persiste, escríbenos a contacto@edify.la";
          isSuccess = true;
        }
        // Otros errores desconocidos
        else {
          errorTitle = "Error Desconocido";
          errorBody = "Ocurrió un error inesperado durante el inicio de sesión. Por favor:\n\n• Verifica tu conexión a internet\n• Intenta nuevamente en unos minutos\n• Si el problema persiste, escríbenos a contacto@edify.la con los detalles del error\n\nDetalles técnicos: " + (error.message || "Error no especificado");
          isSuccess = true;
        }

        dispatch(openMainModal({
          title: errorTitle,
          body: errorBody,
          iconType: errorIconType,
          isSuccess: isSuccess,
          noLabel: noLabel,
          yesLabel: yesLabel,
          confirmHandler: confirmHandler,
          customCloseMainModal: () => {
            dispatch({ type: actionTypes.CLOSE_MAIN_MODAL });
            if (error?.response?.data?.message === "User not found") {
              navigate("/register");
            }
          },
        }));
        dispatch(setLoginAnimation(false));

        dispatch({ type: actionTypes.LOGIN_FAIL, payload: true });
      });
  };
};

export const recoverPasswordAction = (value) => {
  return (dispatch) => {
    dispatch(openEdifySpinner(true));
    dispatch({ type: actionTypes.RECOVERY_START });
    axiosAuth({
      method: "post",
      url: "/user/passwordRecovery",
      params: {
        username: value.email,
      },
      headers: {
        Authorization: "Basic ZWRpZnk6bGFjbGF2ZXNlY3JldGExMjM0",
      },
    })
      .then((response) => {
        dispatch(openEdifySpinner(false));
        dispatch({ type: actionTypes.RECOVERY_SUCCESS });
      })
      .catch((error) => {
        dispatch(openEdifySpinner(false));
        dispatch({ type: actionTypes.RECOVERY_FAIL });

        // Determinar el tipo de error y mostrar mensaje apropiado
        let errorTitle = "¡Ups!";
        let errorBody = "";

        // Errores específicos del servidor
        if (error?.response?.data?.message) {
          const errorMessage = error.response.data.message;

          if (errorMessage.includes("User no encontrado")) {
            errorTitle = "Usuario no encontrado";
            errorBody = "Parece que no existe ningún usuario con ese email. Por favor, comprueba que el email ingresado sea correcto.";
          } else {
            errorBody = `Por favor, intenta nuevamente o escríbenos a contacto@edify.la si el problema persiste.`;
          }
        }
        // Errores de red y CORS
        else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
          errorTitle = "Error de Conexión";
          errorBody = "No se pudo conectar con el servidor para recuperar tu contraseña. Esto puede deberse a:\n\n• Problemas de conexión a internet\n• El servidor no está disponible\n• Problemas de configuración de red\n\nPor favor, verifica tu conexión e intenta nuevamente. Si el problema persiste, escríbenos a contacto@edify.la";
        }
        // Errores de CORS específicos
        else if (error.message && error.message.includes("CORS")) {
          errorTitle = "Error de Configuración";
          errorBody = "Se detectó un problema de configuración de seguridad (CORS) al intentar recuperar tu contraseña. Por favor, intenta nuevamente más tarde o escríbenos a contacto@edify.la si el problema persiste.";
        }
        // Otros errores desconocidos
        else {
          errorTitle = "Error Desconocido";
          errorBody = "Ocurrió un error inesperado al intentar recuperar tu contraseña. Por favor:\n\n• Verifica tu conexión a internet\n• Intenta nuevamente en unos minutos\n• Si el problema persiste, escríbenos a contacto@edify.la con los detalles del error\n\nDetalles técnicos: " + (error.message || "Error no especificado");
        }

        dispatch(
          openMainModal({
            title: errorTitle,
            body: errorBody,
            iconType: "error",
            isSuccess: true,
          })
        );
      });
  };
};


export const setNewPasswordRecovery = (value) => {
  return (dispatch) => {
    dispatch(openEdifySpinner(true));
    axiosAuth({
      method: "post",
      url: "/user/data/password/recover",
      data: {
        password: value.values.password,
        token: value.token,
      },
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        dispatch(openEdifySpinner(false));
        fireAnalytics("reset_password", { 
          category: "authentication",
          session_id: getSessionId(),
          device_category: getDeviceCategory(),
          action: "reset_password"
        });
        dispatch({ type: actionTypes.RECOVERY_SUCCESS });
      })
      .catch((error) => {
        dispatch(openEdifySpinner(false));

        // Determinar el tipo de error y mostrar mensaje apropiado
        let errorTitle = "¡Ups!";
        let errorBody = "";

        // Errores específicos del servidor
        if (error?.response?.data?.message) {
          const errorMessage = error.response.data.message;

          if (errorMessage.includes("expired")) {
            errorTitle = "Token Expirado";
            errorBody = "Tu token de recuperación de contraseña ha expirado. Por favor, vuelve a completar el formulario de 'Olvidé mi contraseña' para recibir un nuevo enlace.";
          } else {
            errorBody = `Por favor, intenta nuevamente o escríbenos a contacto@edify.la si el problema persiste.`;
          }
        }
        // Errores de red y CORS
        else if (error.code === "ERR_NETWORK" || error.message === "Network Error") {
          errorTitle = "Error de Conexión";
          errorBody = "No se pudo conectar con el servidor para cambiar tu contraseña. Esto puede deberse a:\n\n• Problemas de conexión a internet\n• El servidor no está disponible\n• Problemas de configuración de red\n\nPor favor, verifica tu conexión e intenta nuevamente. Si el problema persiste, escríbenos a contacto@edify.la";
        }
        // Errores de CORS específicos
        else if (error.message && error.message.includes("CORS")) {
          errorTitle = "Error de Configuración";
          errorBody = "Se detectó un problema de configuración de seguridad (CORS) al intentar cambiar tu contraseña. Por favor, intenta nuevamente más tarde o escríbenos a contacto@edify.la si el problema persiste.";
        }
        // Otros errores desconocidos
        else {
          errorTitle = "Error Desconocido";
          errorBody = "Ocurrió un error inesperado al intentar cambiar tu contraseña. Por favor:\n\n• Verifica tu conexión a internet\n• Intenta nuevamente en unos minutos\n• Si el problema persiste, escríbenos a contacto@edify.la con los detalles del error\n\nDetalles técnicos: " + (error.message || "Error no especificado");
        }

        dispatch(
          openMainModal({
            title: errorTitle,
            body: errorBody,
            iconType: "error",
            isSuccess: false,
          })
        );
      });
  };
};


export const logoutAction = () => {
  return {
    type: actionTypes.LOGOUT,
  };
};

export const setLoginType = (value) => {
  return {
    type: actionTypes.LOGIN_TYPE,
    payload: value,
  };
};

function removeItems(dispatch) {
  // Limpiar tokens de autenticación
  localStorage.removeItem("access-RefreshToken-Edify");
  localStorage.removeItem("access-Token-Edify");
  
  // Limpiar datos de persistencia de Redux
  localStorage.removeItem("saveForm");
  localStorage.removeItem("persist:register");
  localStorage.removeItem("persist:root");
  localStorage.removeItem("persist:category");
  localStorage.removeItem("persist:profile");
  localStorage.removeItem("persist:general");
  localStorage.removeItem("persist:onboardingV2");
  
  // Limpiar datos del flujo de registro
  clearRegistrationData(dispatch);
  dispatch(clearRegistrationV2Flow());
  clearCurrentSessionPointer(undefined);
  sessionStorage.removeItem("edify_commerce_dash_banner_hide");
}
export const logout = (hasnavigate, navigate) => {
  return (dispatch, getState) => {
    // Obtener userData antes de limpiar
    const userData = getState().general.userData;
    if (userData?.id != null && String(userData.id).length > 0) {
      clearCurrentSessionPointer(String(userData.id));
    }

    // Trackear logout
    fireAnalytics("auth_logout", {
      edify_user_id: userData?.id || "",
      session_id: getSessionId(),
      device_category: getDeviceCategory(),
      category: "authentication",
      action: "logout"
    });
    
    if (hasnavigate) {
      dispatch(setLogoutAnimation(true));
      setTimeout(() => {
        removeItems(dispatch);
        dispatch(logoutAction());
        dispatch(setLogoutAnimation(false));
        navigate("/");
      }, 1500);
    } else {
      dispatch(setLogoutAnimation(true));
      setTimeout(() => {
        removeItems(dispatch);
        dispatch(logoutAction());
        dispatch(setLogoutAnimation(false));
      }, 1500);
    } 
  }
}

export const loginGuestAccount = () => {
  return async (dispatch) => {
    if (localStorage.getItem("access-Token-Edify")) {
      return;
    } else {
      return axiosAuth
        .get("/oauth/token/invited")
        .then((body) => {
          dispatch(setLoginAnimation(true));
          const access_token = body.data.access_token;
          const authHeaders = {
            headers: { Authorization: `Bearer ${access_token}` },
          };
          localStorage.setItem("access-Token-Edify", access_token);
          localStorage.setItem("access-RefreshToken-Edify", access_token);
          dispatch(setLoginAnimation(false));
          dispatch({ type: actionTypes.LOGIN_SUCCESS });
          dispatch(resetOnboarding());
          localStorage.removeItem("persist:onboardingV2");
          return axiosAuth.get("/user/data", authHeaders).then((res) => {
            dispatch({ type: actionTypes.GET_DATA, payload: res.data });
            dispatch(refreshCommerceOnboardingEligibility(res.data));
            return;
          });
        })
        .catch((error) => {
          dispatch(setLoginAnimation(false));
          console.error("error", error);
        });
    }
  };
};

export const logoutFromGuestAccount = (navigate) => {
  return (dispatch) => {
    if (navigate) {
      navigate("/register");
      dispatch(setLogoutAnimation(true));
      setTimeout(() => {
        removeItems(dispatch);
        dispatch(logoutAction());
        dispatch(setLogoutAnimation(false));
      }, 1500);
    } else {
      removeItems(dispatch);
      dispatch(logoutAction());
    }
  }
};

export const deleteUserAccount = (message = null) => {
  return (dispatch, getState) => {
    let authToken = localStorage.getItem("access-Token-Edify");
    let bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
    
    dispatch(openEdifySpinner(true));

    const isProduction = environment.isProduction;
    const userReceiverId = isProduction ? 903 : 688;
    const currentUser = getState().general.userData;
    const userId = currentUser?.id || null;

    const deleteAccount = () => {
      axiosAuth
        .delete("/user/client", bearerToken)
        .then(() => {
          dispatch(openEdifySpinner(false));
          removeItems(dispatch);
          dispatch(logoutAction());
          dispatch(
            openMainModal({
              title: "Cuenta eliminada",
              body: "Tu cuenta ha sido eliminada correctamente. Gracias por haber sido parte de Edify.",
              isSuccess: true,
              iconType: "success",
              confirmHandler: () => {
                window.location.replace(window.location.origin);
              },
            })
          );
        })
        .catch((error) => {
          dispatch(openEdifySpinner(false));
          let errorTitle = "Error al eliminar cuenta";
          let errorBody = "No hemos podido eliminar tu cuenta. Por favor, intenta nuevamente o escríbenos a contacto@edify.la si el problema persiste.";

          if (error?.response?.data?.message) {
            errorBody = `Por favor, intenta nuevamente o escríbenos a contacto@edify.la.`;
          }

          dispatch(
            openMainModal({
              title: errorTitle,
              body: errorBody,
              iconType: "error",
              isSuccess: true,
              confirmHandler: null,
            })
          );
        });
    };

    if (message) {
      const messageWithUserId = userId 
        ? `[Usuario ID: ${userId}]\n\n${message}`
        : message;
      
      const contactNotification = {
        userReceiver: userReceiverId,
        message: messageWithUserId
      };

      axios
        .post("notificaciones/send-contact", contactNotification, bearerToken)
        .then(() => {
          deleteAccount();
        })
        .catch(() => {
          deleteAccount();
        });
    } else {
      deleteAccount();
    }
  };
};

// Función movida desde profileActions.js para evitar dependencia circular
export const viewAccessRequest = () => (dispatch) => {
  const authToken = localStorage.getItem("access-Token-Edify");
  if (!authToken) return;
  const bearerToken = { headers: { Authorization: `Bearer ${authToken}` } };
  axios
    .get("/notificaciones/get", bearerToken)
    .then((res) => {
      const list = Array.isArray(res?.data) ? res.data : (res?.data?.data ?? []);
      dispatch({
        type: actionTypes.GET_SOLICITUDE_LIST,
        payload: list,
      });
    })
    .catch(() => {
      dispatch({
        type: actionTypes.GET_SOLICITUDE_LIST,
        payload: [],
      });
    });
};
